
import { Venue } from '../Venue';
export class VenueOfPartner extends Venue {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
    this.noAdd = true
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/VenueOfPartner.js